/** Switch quotes within each testimonial block. */
export function initTestimonials(scope = document) {
  scope.querySelectorAll('.quotes').forEach((group) => {
    if (group.dataset.testimonialsReady) return;
    group.dataset.testimonialsReady = 'true';
    const people = Array.from(group.querySelectorAll('.person[aria-pressed]'));
    const quotes = Array.from(group.querySelectorAll('.quote'));
    people.forEach((button, index) => {
      button.addEventListener('click', () => {
        const selected = Number(button.dataset.q ?? index);
        if (!quotes[selected]) return;
        people.forEach((person) =>
          person.setAttribute('aria-pressed', String(person === button))
        );
        quotes.forEach((quote, quoteIndex) => {
          quote.hidden = quoteIndex !== selected;
          quote.classList.toggle('is-active', quoteIndex === selected);
        });
      });
    });
  });
}
